import { useMemo } from 'react';

import {
  getSupporterDataIssues,
  useSupporterDataStatus,
} from '@sola/supporter-sdk/hooks/data-status.ts';
import type { SupporterQueryPart } from '@sola/supporter-sdk/queries.ts';

import {
  createPartialDataAlert,
  createPartialDataAlertMulti,
} from '../../utils/alerts.tsx';
import { LocalAlert } from '../local-alerts/local-alerts.tsx';

export const PrimerError: React.FC<{ keysToAlert?: SupporterQueryPart[] }> = ({
  keysToAlert,
}) => {
  const { data: dataStatus } = useSupporterDataStatus();

  const dataAlert = useMemo(() => {
    const issues = getSupporterDataIssues(dataStatus, keysToAlert);

    if (issues.length === 0) {
      return null;
    }

    return issues.length === 1
      ? createPartialDataAlert(issues[0].key)
      : createPartialDataAlertMulti();
  }, [dataStatus, keysToAlert]);

  if (!dataAlert) {
    return null;
  }

  return (
    <LocalAlert
      alert={{ id: 'dataAlert', ...dataAlert }}
      scrollIntoView={false}
    />
  );
};
